import { render, staticRenderFns } from "./MyTrades.vue?vue&type=template&id=6489c8ac&scoped=true"
import script from "./MyTrades.vue?vue&type=script&lang=js"
export * from "./MyTrades.vue?vue&type=script&lang=js"
import style0 from "./MyTrades.vue?vue&type=style&index=0&id=6489c8ac&prod&lang=scss&scoped=true"
import style1 from "./MyTrades.vue?vue&type=style&index=1&id=6489c8ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6489c8ac",
  null
  
)

export default component.exports